import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { service } from '../utility/service'
import { NavLink } from 'react-router-dom'


function Service() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }
    return (
        <>
            <section className="section-breadcrumb">
                <div className="top_outline_01"></div>
                <div className="top_outline_02"></div>
                <div className="bottom_outline_01"></div>
                <div className="bottom_outline_02"></div>
                <div className="container-fulid">
                    <div className="row">
                        <div className="col-12">
                            <div className="zx-breadcrumb padding-tb-100">
                                <div className="banner mb-15 justify-content-center">
                                    <h2>Services</h2>
                                </div>
                                <div className="entry-breadcrumb">
                                    <h5>
                                        <span>
                                            <NavLink to="/">Home</NavLink>
                                        </span>
                                        <span> / </span>
                                        <span className="post-page">
                                            <NavLink to="/service">Services</NavLink>
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-services padding-tb-100">
                <div className="container">
                    <Fade triggerOnce direction='up' duration={1500} className="row zx-service-box mb-m-24">
                        <>
                            {
                                service.map((data, index) => (
                                    <div key={index} className="col-xl-3 col-lg-6 col-md-6 col-sm-12 zx-serch-main">

                                        <div className="zx-service">
                                            <img src={data.image} alt="maeketing" />
                                            <div className="zx-market">
                                                <h4>{data.title}</h4>
                                                <p>
                                                    {data.discription}
                                                </p>
                                            </div>
                                            <div className="active-read">
                                                <a onClick={handleSubmit} href="/">Read more</a>
                                                <i className="fa-solid fa-arrow-right-long"></i>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </>
                    </Fade>
                </div>
            </section >
        </>
    )
}

export default Service
